import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48323c64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_canjiandanwei = _resolveComponent("canjiandanwei")!
  const _component_usermanger = _resolveComponent("usermanger")!
  const _component_areatype = _resolveComponent("areatype")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createVNode(_component_van_form, { onSubmit: _ctx.onSubmit }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value) = $event)),
            rules: [{ required: true, message: '区域名称必填' }],
            required: "",
            label: "区域名称",
            placeholder: "请填写区域名称",
            maxlength: "50"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_canjiandanwei, { onSelectCompany: _ctx.selectCompany }, null, 8, ["onSelectCompany"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_usermanger, { onSelectUserManger: _ctx.selectUserManger }, null, 8, ["onSelectUserManger"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_areatype, { onSelectArea: _ctx.selectArea }, null, 8, ["onSelectArea"])
        ]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_van_button, {
            block: "",
            type: "primary",
            disabled: _ctx.flag,
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}